import React from "react";
import styled, { useTheme } from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import LabelView from "@components/molecules/LabelView";
import { getDiamondValue } from "@utils/product/productFormatters";
import { useTypographyStore } from "@redux/slices/typographySlice";

export enum ProductCategory {
  DIAMOND = "diamond",
  GEMSTONE = "gemstone",
  JEWELRY = "jewelry",
  LAB_GROWN_DIAMOND = "lab_grown_diamond",
  LABGROWN_JEWELRY = "lab_grown_jewelry",
  DEFAULT = "default",
}

const ExtraDetailsContainer = ({
  stockItem,
  productType,
  isBulkList = false,
}: any) => {
  const typography = useTypographyStore();
  const theme = useTheme();

  const renderDiamondView = () => (
    <>
      <SectionContainer>
        <Upper>
          <LabelView
            itemLeftText="D"
            itemRightText={getDiamondValue("Depth", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
          <LabelView
            itemLeftText="T"
            itemRightText={getDiamondValue("Table", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Bottom>
          <LabelView
            itemLeftText="Grdl"
            itemRightText={getDiamondValue("Girdle", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Bottom>
      </SectionContainer>
      {!theme.isMobile && (
        <SectionContainer>
          <Upper>
            <LabelView
              itemLeftText="M"
              itemRightText={getDiamondValue("Meas", stockItem)}
              leftPostfixText=":"
              keyTypographyStyle={typography["Minor-R"]}
              valueTypographyStyle={typography["Minor-M"]}
              allowSpaceAfterLeftText={false}
            />
          </Upper>
          <Bottom>
            <LabelView
              itemLeftText="Crw"
              itemRightText={getDiamondValue("Crown", stockItem)}
              leftPostfixText=":"
              keyTypographyStyle={typography["Minor-R"]}
              valueTypographyStyle={typography["Minor-M"]}
              allowSpaceAfterLeftText={false}
            />
          </Bottom>
        </SectionContainer>
      )}
      <SectionContainer>
        <Upper>
          <LabelView
            itemLeftText="Ratio"
            itemRightText={getDiamondValue("Ratio", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Bottom>
          <LabelView
            itemLeftText="Pav"
            itemRightText={getDiamondValue("Pavilion", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Bottom>
      </SectionContainer>
    </>
  );

  const renderMobileDiamondView = () => (
    <>
      <SectionContainer>
        <Upper>
          <LabelView
            itemLeftText="D"
            itemRightText={getDiamondValue("Depth", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
          <LabelView
            itemLeftText="T"
            itemRightText={getDiamondValue("Table", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Upper>
          <LabelView
            itemLeftText="Ratio"
            itemRightText={getDiamondValue("Ratio", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Bottom>
          <LabelView
            itemLeftText="Crw"
            itemRightText={getDiamondValue("Crown", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Bottom>
      </SectionContainer>

      <SectionContainer>
        <Upper>
          <LabelView
            itemLeftText="M"
            itemRightText={getDiamondValue("Meas", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Upper>
          <LabelView
            itemLeftText="Grdl"
            itemRightText={getDiamondValue("Girdle", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Bottom>
          <LabelView
            itemLeftText="Pav"
            itemRightText={getDiamondValue("Pavilion", stockItem)}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Bottom>
      </SectionContainer>
    </>
  );

  const renderGemstoneView = () => (
    <>
      <SectionContainer>
        <Upper>
          <LabelView
            itemLeftText="Type"
            itemRightText={stockItem?.type || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Bottom>
          <LabelView
            itemLeftText="Shape"
            itemRightText={stockItem?.shape || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Bottom>
      </SectionContainer>
      <SectionContainer>
        <Upper>
          <LabelView
            itemLeftText="Carat Weight"
            itemRightText={stockItem?.center_size || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
          <LabelView
            itemLeftText="Color"
            itemRightText={stockItem?.color || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Bottom>
          <LabelView
            itemLeftText="Lab"
            itemRightText={stockItem?.lab || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Bottom>
      </SectionContainer>
    </>
  );

  const renderJewelryView = () => (
    <>
      <SectionContainer>
        <Upper>
          <LabelView
            itemLeftText="Type"
            itemRightText={stockItem?.type || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Bottom>
          <LabelView
            itemLeftText="Metal"
            itemRightText={stockItem.metal || stockItem?.metals || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Bottom>
      </SectionContainer>
      <SectionContainer>
        <Upper>
          <LabelView
            itemLeftText="Size"
            itemRightText={stockItem.size || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Upper>
        <Bottom>
          <LabelView
            itemLeftText="Carat Weight"
            itemRightText={stockItem?.center_size || "-"}
            leftPostfixText=":"
            keyTypographyStyle={typography["Minor-R"]}
            valueTypographyStyle={typography["Minor-M"]}
            allowSpaceAfterLeftText={false}
          />
        </Bottom>
      </SectionContainer>
    </>
  );

  const renderContent = () => {
    switch (productType?.productType) {
      case ProductCategory.GEMSTONE:
        return renderGemstoneView();
      case ProductCategory.JEWELRY:
      case ProductCategory.LABGROWN_JEWELRY:
        return renderJewelryView();
      case ProductCategory.DIAMOND:
      case ProductCategory.LAB_GROWN_DIAMOND:
      default:
        return theme.isMobile ? renderMobileDiamondView() : renderDiamondView();
    }
  };

  return (
    <MiddleContainer isBulkList={isBulkList}>{renderContent()}</MiddleContainer>
  );
};

const MiddleContainer = styled.View<{
  isBulkList?: boolean;
}>`
  padding-left: ${SpaceType.Basic}px;
  padding-right: ${SpaceType.Basic}px;
  padding-top: ${SpaceType.Basic}px;
  padding-bottom: ${SpaceType.Basic}px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-02"]};
  justify-content: space-between;
`;

const SectionContainer = styled.View`
  flex-direction: column;
  gap: ${SpaceType.ExtraSmall}px;
  margin-right: ${({ theme }) => (theme.isMobile ? 0 : "50px")};
`;

const Upper = styled.View`
  gap: ${SpaceType.Double}px;
  flex-direction: row;
`;

const Bottom = styled.View``;

export default React.memo(ExtraDetailsContainer);
